module.exports = __webpack_public_path__ + "images/ui-bg_glass_100_fdf5ce_1x400.png";